import {
  type CountryCode,
  parsePhoneNumberFromString,
} from 'libphonenumber-js';

export const formatPhoneNumber = (
  phoneNumber: string | number | null | undefined,
  defaultCountry: CountryCode = 'US'
): string => {
  if (!phoneNumber) {
    return '';
  }

  const phoneString = String(phoneNumber).trim();

  if (!phoneString) {
    return '';
  }

  try {
    const parsed = parsePhoneNumberFromString(phoneString, defaultCountry);

    if (parsed?.isValid()) {
      return parsed.formatNational();
    }

    return phoneString;
  } catch {
    return phoneString;
  }
};
